import { md5 } from '@/helper/Crypt';
import kebabCase from 'lodash/kebabCase';

export const _k = (text) => {
    
    if (typeof text !== 'string') 
        return {
            key: text,
            text: text
        };

    let orgText = text;
    let resText = text;
    let respons = '';

    const regex = /\{{(.+?)\}}/g;
    const match = text?.match(regex);

    if (typeof text === 'undefined' || text === null) {
        return null;
    }

    match?.map((item, index) => {
        let _text = item?.replace('{{', '')?.replace('}}', '');
        resText = resText.replace(_text, '$' + index);
    })

    const keyedText = 'A' + md5(kebabCase(resText));
    
    return {
        key: keyedText,
        text: resText
    };
}